import { WeeklyPlanningResetKind, WeeklyPlanningWriteCase } from "src/model/enum/enumWeeklyPlanning";
import { WeeklyPlanningAction } from "./weekly-planning-action";

export class WeeklyPlanning {
    public id: number = 0;
    public name: string = "";
    public description: string = "";
    public active: boolean = true;
    public instanceguid: string = "";
    public address: string = "";
    public writeCase: number = WeeklyPlanningWriteCase.Always;
    public resetkind: number = WeeklyPlanningResetKind.None;
    public resettimestring: string = "01-01-0001 00:00:00";
    public resetminutes: number = 0;
    public instanceguidCommandAddress: string = "";
    public commandAddress: string = "";
    public instanceguidStateAddress: string = "";
    public stateAddress: string = "";
    public t1: string  = "";
    public t2: string = "";
    public t3: string = "";
    public t4: string = "";
    public t5: string = "";
    public t1Color: string = "";
    public t2Color: string = "";
    public t3Color: string = "";
    public t4Color: string = "";
    public t5Color: string = "";
    public suspendOnExternalVariation: boolean = false;
    public actions: Array<WeeklyPlanningAction> = new Array<WeeklyPlanningAction>();
    public calendarIDs: number[] = [];
    public idEnvironment: number = -1;

    constructor(weeklyPlanningType?: any) {
        // used for assign type to instance of object
        if (weeklyPlanningType) {
          Object.assign(this, weeklyPlanningType);
        }
      }

    /**
     * Tell whether a weekly planning holds the minimum configuration its time-bands can be drawn
     * from: the gateway instance and the address it writes to, plus at least one of the T values.
     *
     * Without an address there are no methods to resolve the T values against, and with no T value
     * at all every state name resolves to an empty string: the charts would still paint a mute
     * full-day slice, with a blank legend, and the period dialog would offer nothing to pick.
     *
     * Static (and not a getter) on purpose: the lists travel as plain JSON from storage and from
     * the API, so the objects handed around are rarely real instances of this class.
     *
     * @param weeklyPlanning the weekly planning to test
     * @returns true when the weekly planning can be viewed and edited as time-bands
     */
    public static isViewable(weeklyPlanning: WeeklyPlanning): boolean {
      return (
        !!weeklyPlanning &&
        !!weeklyPlanning.instanceguid &&
        !!weeklyPlanning.address &&
        !!(
          weeklyPlanning.t1 ||
          weeklyPlanning.t2 ||
          weeklyPlanning.t3 ||
          weeklyPlanning.t4 ||
          weeklyPlanning.t5
        )
      );
    }
}

export class WeeklyPlanningCopyData {
  public DayFrom: number = 0;
  public DaysTo: string = "";
  public IDWeeklyPlanning: number = 0;
}
